import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/lib/theme';

export function ThemeToggle({ className = '' }: { className?: string }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === 'dark';
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? 'Attiva tema chiaro' : 'Attiva tema scuro'}
      className={`relative p-2.5 rounded-xl bg-surface-2 hover:bg-accent text-foreground transition-colors ${className}`}
    >
      <Sun
        className={`w-5 h-5 transition-all ${
          isDark ? 'scale-0 -rotate-90 absolute inset-0 m-auto' : 'scale-100 rotate-0'
        }`}
      />
      <Moon
        className={`w-5 h-5 transition-all ${
          isDark ? 'scale-100 rotate-0' : 'scale-0 rotate-90 absolute inset-0 m-auto'
        }`}
      />
    </button>
  );
}
